import {
  ACTIVATE_EMPLOYEE_REQUEST,
  ADD_EMPLOYEE_REQUEST,
  DEACTIVATE_EMPLOYEE_REQUEST,
  EDIT_EMPLOYEE_REQUEST,
  EMPLOYEES_LIST_REQUEST,
  EMPLOYEES_LIST_RESPONSE,
  GET_EMPLOYEE_DETAILS_REQUEST,
  GET_EMPLOYEE_DETAILS_RESPONSE
} from "./types";

export const employeesListRequest = (payload) => ({
  type: EMPLOYEES_LIST_REQUEST,
  payload
});
export const employeesListResponse = (payload) => ({
  type: EMPLOYEES_LIST_RESPONSE,
  payload
});

export const addEmployeeRequest = (payload) => ({
  type: ADD_EMPLOYEE_REQUEST,
  payload
});

export const getEmployeeDetailsRequest = (payload) => ({
  type: GET_EMPLOYEE_DETAILS_REQUEST,
  payload
});

export const getEmployeeDetailsResponse = (payload) => ({
  type: GET_EMPLOYEE_DETAILS_RESPONSE,
  payload
});

export const editEmployeeRequest = (payload) => ({
  type: EDIT_EMPLOYEE_REQUEST,
  payload
});

export const activateEmployeeRequest = (payload) => ({
  type: ACTIVATE_EMPLOYEE_REQUEST,
  payload
});
export const deactivateEmployeeRequest = (payload) => ({
  type: DEACTIVATE_EMPLOYEE_REQUEST,
  payload
});
